import lang from '/@/modules/core/app/services/Lang';
import Locale from '/@/modules/user/Enum/Locale';
import messages from '/@/locales/en.json';

type I18nValues = Record<string, string | number | boolean | null | undefined>;

class Lang {
  init(): void {
    // Vue I18n v9+ requires accessing via .global in legacy mode
    lang.i18n.global.setLocaleMessage(Locale.ENGLISH.key, lang.cleanDictionary(messages));
    lang.loadedLanguages.push(Locale.ENGLISH.key);
  }

  t(str: string, interpolations: I18nValues = {}): string {
    if (!lang.loadedLanguages.includes(Locale.ENGLISH.key)) {
      this.init();
    }
    return lang.t(str, interpolations);
  }

  tc(str: string, count: number, interpolations: I18nValues = {}): string {
    if (!lang.loadedLanguages.includes(Locale.ENGLISH.key)) {
      this.init();
    }
    return lang.tc(str, count, interpolations);
  }
}

export default new Lang();
